import React from 'react';
import { Box, StackLayout, UtilityText } from '@leagueplatform/genesis-core';
import { Badge } from '@leagueplatform/web-common-components';
import { LEADERBOARD_RANKING_UNIT } from '@leagueplatform/health-journey-api';
import { ChallengeProfilePicture } from '#components/challenge-profile-picture/challenge-profile-picture.component.tsx';
import { ChallengeUnitIcon } from './challenge-unit-icon.component';

type LeaderboardRankProps = {
  rank: number;
  rankingUnit: LEADERBOARD_RANKING_UNIT;
  score: number;
  avatarUrl?: string;
  highlight: boolean;
  initials: string;
  name: string;
};

export function LeaderboardRank({
  name,
  rank,
  rankingUnit,
  score,
  avatarUrl,
  highlight,
  initials,
}: LeaderboardRankProps) {
  return (
    <StackLayout
      as="li"
      orientation="horizontal"
      verticalAlignment="center"
      css={{
        backgroundColor: highlight ? '$highlightBackgroundSubdued' : 'inherit',
        paddingBlock: '$one',
        paddingInline: '$half',
      }}
      spacing="$threeQuarters"
    >
      <UtilityText emphasis="subtle">{rank}</UtilityText>
      <Box css={{ width: '$two', height: '$two' }}>
        <ChallengeProfilePicture
          profilePicture={avatarUrl}
          initials={initials}
          backgroundColor="$decorativeBrandPrimaryDefault"
        />
      </Box>
      <StackLayout
        orientation="horizontal"
        horizontalAlignment="spaceBetween"
        verticalAlignment="center"
      >
        <UtilityText emphasis="emphasized" size="sm">
          {name}
        </UtilityText>
        <Badge
          css={{
            backgroundColor: highlight
              ? '$decorativeBrandPrimaryDarkest'
              : '$surfaceBackgroundTertiary',
            color: highlight
              ? '$onSurfaceTextReversed'
              : '$onSurfaceTextPrimary',
            fontWeight: '$regular',
            fontSize: '$subtitleTwo',
            '@mobile': { fontSize: '$overline' },
          }}
        >
          <ChallengeUnitIcon score={score} rankingUnit={rankingUnit} />
        </Badge>
      </StackLayout>
    </StackLayout>
  );
}
